import { Ruler } from "lucide-react";

import { Button } from "@/components/ui/button";

export function MeasureButton({
	stageName,
	onClick,
	className,
}: {
	stageName: string;
	onClick: () => void;
	className?: string;
}) {
	return (
		<Button
			type="button"
			variant="ghost"
			size="icon"
			className={className}
			onClick={onClick}
			aria-label={`Lançar medição de ${stageName}`}
		>
			<Ruler />
		</Button>
	);
}
